<template>
  <generic-modal
    size="small"
    :title="$t('jwt')"
    icon="eye"
    image="/images/icons/jwt.png"
    v-on:destroy="$emit('destroy')"
    :on_finished="finished"
    :scrolling="false"
  >
    <div class="description">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li
            v-html="
              $t(
                'validity time describing a timespan (ex: 7d). more info in (https://github.com/vercel/ms)',
              )
            "
          ></li>
          <li
            v-html="
              $t(
                'key to generate token should match witch key for token verification',
              )
            "
          ></li>
        </ul>
      </div>
      <div class="ui form" ref="form">
        <div class="two fields" v-show="true">
          <div class="field">
            <label for>{{ $t("key") }}</label>
            <input type="text" name="key" v-model="key" />
          </div>
          <div class="field">
            <label for>{{ $t("token name") }}</label>
            <input type="text" name="name" v-model="name" />
          </div>
        </div>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("validity time") }}</label>
            <input type="text" name="validity_time" v-model="validity_time" />
          </div>
          <div class="field">
            <label for>{{ $t("algorithm") }}</label>
            <div class="ui selection dropdown" ref="algorithm_dropdown">
              <input type="hidden" name="algorithm" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import GenericModal from "@/components/GenericModal";
import filters from "@/filters";
import moment from "moment";
import {
  // error_toast,
  local_api,
  enterprise_setup,
} from "@/utils";

export default {
  name: "APIManagerJWTModal",
  filters: filters,
  components: {
    "generic-modal": GenericModal,
  },
  props: {},
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      key: "",
      name: "",
      validity_time: "7d",
      algorithm: "none",
      form: undefined,
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise((resolve, reject) => {
        // Validate form
        let isValid = vm.form.form("validate form");
        if (!isValid) reject();
        else {
          local_api(vm, "post", "/api_manager/do-create-jwt-token", {
            n: vm.name,
            k: vm.key,
            a: vm.algorithm,
            t: vm.validity_time,
          })
            .then((token) => {
              let r = {
                name: vm.name,
                key: vm.key,
                token: token,
                algorithm: vm.algorithm,
                create_date: moment().toISOString(),
                validity_time: vm.validity_time,
              };
              vm.$emit("created", r);
              resolve(r);
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    set_key_token(opts) {
      // console.log("set key token", opts);
      this.key = opts.key;
      this.name = opts.name;
    },
  },
  mounted() {
    let vm = this;

    // Form init
    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        key: ["empty"],
        name: ["empty"],
        validity_time: ["empty"],
        algorithm: ["empty"],
      },
    });

    let vls = [
      { name: vm.$t("hmac using sha-256 hash algorithm"), value: "HS256" },
      { name: vm.$t("hmac using sha-384 hash algorithm"), value: "HS384" },
      { name: vm.$t("hmac using sha-512 hash algorithm"), value: "HS512" },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-256 hash algorithm"),
        value: "RS256",
      },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-384 hash algorithm"),
        value: "RS384",
      },
      {
        name: vm.$t("rsassa-pkcs1-v1_5 using sha-512 hash algorithm"),
        value: "RS512",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-256 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS256",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-384 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS384",
      },
      {
        name: vm.$t(
          "rsassa-pss using sha-512 hash algorithm (only node ^6.12.0 or >=8.0.0)",
        ),
        value: "PS512",
      },
      {
        name: vm.$t("ecdsa using p-256 curve and sha-256 hash algorithm"),
        value: "ES256",
      },
      {
        name: vm.$t("ecdsa using p-384 curve and sha-384 hash algorithm"),
        value: "ES384",
      },
      {
        name: vm.$t("ecdsa using p-521 curve and sha-512 hash algorithm"),
        value: "ES512",
      },
      {
        name: vm.$t("none"),
        value: "none",
      },
    ];
    window
      .jQuery(vm.$refs.algorithm_dropdown)
      .dropdown("setup menu", { values: vls })
      .dropdown({
        onChange(value) {
          vm.algorithm = value;
        },
      });
  },
  watch: {},
  updated: function () {},
};
</script>
